<template>
  <div>
    <Title :pages="[{ icon: 'layer-group', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                    <v-combobox
                      v-model="filters.sucursal"
                      item-title="label"
                      item-value="id"
                      :items="sucursales"
                      label="Sucursal"
                      autocomplete="off"
                      :disabled="disabled"
                      clearable
                      :loading="loading_sucursales"
                    ></v-combobox>
                </div>

                <div class="col-md-9 mt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>              
              <td>{{ item.name }}</td>
              <td>{{ item.sucursal != null ? item.sucursal.name : "-" }}</td>
              <td>{{ item.high }}</td>
              <td>{{ item.width }}</td>
              <td>{{ item.length }}</td>
              <td>{{ item.max_weight }}</td>
              <td>{{ item.max_cant_pallets != null ? item.max_cant_pallets : "-" }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { sucursalService } from "@/libs/ws/sucursalService";
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";

export default {
  components: { Modal },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: tipoUbicacionService,
      page_title: "Tipos de ubicaciones",
      modal_title: "Tipo de ubicación",
      headers: [
        {
          title: "Nombre",
          align: "left",
          sortable: true,
          key: "name",
        },
        {
          title: "Susursal",
          align: "left",
          sortable: true,
          key: "sucursal.name",
        },
        { title: "Alto", align: "left", sortable: true, key: "high" },
        { title: "Ancho", align: "left", sortable: true, key: "width" },
        { title: "Largo", align: "left", sortable: true, key: "length" },
        { title: "Peso maximo", align: "left", sortable: true, key: "max_weight" },
        { title: "Max Pallet", align: "left", sortable: true, key: "max_cant_pallets" },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      sucursales: [],
      filters: {        
        sucursal: "",        
      },
      loading_sucursales: false,
    };
  },
  mounted() {
    this.loadSucursales();
    this.loadList(this.service);
  },
  methods: {
    filter() {
      this.loadList(this.service);
    },
    getFilterParams() {
      // La tabla pagina del lado del cliente: se pide el listado completo
      return { ...this.filters, limit: 0 };
    },
    loadSucursales() {
      this.loading_sucursales = true;
      sucursalService
        .filter()
        .then((response) => {
          this.sucursales = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_sucursales = false;
        });
    },
  },
};
</script>
